var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      _c(
        "b-card",
        { staticClass: "mb-4" },
        [
          _c(
            "b-row",
            { attrs: { "align-v": "center" } },
            [
              _c(
                "b-col",
                { attrs: { cols: "12", md: "6", lg: "4" } },
                [
                  _c("label", { staticClass: "mb-2 font-weight-bold" }, [
                    _vm._v("Select Date Range to View Reports"),
                  ]),
                  _c("DatePicker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      range: "",
                      format: "YYYY-MM-DD",
                      placeholder: "Select date range",
                      size: "sm",
                    },
                    on: { change: _vm.handleDateRangeChange },
                    model: {
                      value: _vm.dateRange,
                      callback: function ($$v) {
                        _vm.dateRange = $$v
                      },
                      expression: "dateRange",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                {
                  staticClass: "mt-3 mt-md-0",
                  attrs: { cols: "12", md: "6", lg: "4" },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-md-2",
                      attrs: { variant: "primary", disabled: !_vm.dateRange },
                      on: { click: _vm.handleDateRangeChange },
                    },
                    [_vm._v(" Refresh Reports ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-4" },
            [
              _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Loading reports..." },
              }),
              _c("p", { staticClass: "ml-3 mb-0 align-self-center" }, [
                _vm._v("Loading reports..."),
              ]),
            ],
            1
          )
        : _vm._e(),
      !_vm.dateRange && !_vm.loading
        ? _c("b-alert", { attrs: { show: "", variant: "info" } }, [
            _vm._v(" Please select a date range above to view the reports. "),
          ])
        : _vm._e(),
      _vm.dateRange && !_vm.loading
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mb-4", attrs: { cols: "12" } },
                [
                  _c("b-card", [
                    _vm.costAnalysisData && _vm.costAnalysisData.length
                      ? _c(
                          "div",
                          [
                            _c("Chart", {
                              attrs: { costData: _vm.costAnalysisData },
                            }),
                          ],
                          1
                        )
                      : _c("div", { staticClass: "text-center py-5" }, [
                          _c("i", {
                            staticClass: "fas fa-chart-line text-muted mb-3",
                            staticStyle: { "font-size": "3rem" },
                          }),
                          _c("h4", { staticClass: "text-muted" }, [
                            _vm._v("No Cost Analysis Data Available"),
                          ]),
                          _c("p", [
                            _vm._v(
                              "There is no cost analysis data for the selected date range. Try selecting a different period."
                            ),
                          ]),
                        ]),
                  ]),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-card", [
                    _vm.projectStatusData && _vm.projectStatusData.length
                      ? _c(
                          "div",
                          [
                            _c("DonutChart", {
                              attrs: { statusData: _vm.projectStatusData },
                            }),
                          ],
                          1
                        )
                      : _c("div", { staticClass: "text-center py-5" }, [
                          _c("i", {
                            staticClass: "fas fa-chart-pie text-muted mb-3",
                            staticStyle: { "font-size": "3rem" },
                          }),
                          _c("h4", { staticClass: "text-muted" }, [
                            _vm._v("No Project Status Data Available"),
                          ]),
                          _c("p", [
                            _vm._v(
                              "There is no project status data for the selected date range. Try selecting a different period."
                            ),
                          ]),
                        ]),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }